import { put, takeLatest } from "@redux-saga/core/effects";
import AxiosCustom from "../../../components/common/apiConfig";

  export const actionTypes = {
      reportTradeDetail:"[reportTradeDetail] Action",
      reportTradeDetailLoad:"[reportTradeDetailLoad] Action",
      reportTradeDetailAsync:"[reportTradeDetailAsync] Action",
      reportTradeDetailEmpty:"[reportTradeDetailEmpty] Action"
  }


  const initialState={
      data:[],
      size:20,
      total:0,
      loading:false
  }


  export const report_trade_detail_reducer = (state=initialState,{type,payload})=>{
    switch (type) {
        case actionTypes.reportTradeDetail:
          return {
            ...state,
            data: payload.results,
            total: payload.total 
            ? payload.total >10000
            ?10000
            :payload.total 
            : 0
          };
        case actionTypes.reportTradeDetailLoad:
          return {
            ...state,
            loading:payload
          };
        case actionTypes.reportTradeDetailEmpty:
          return initialState
        default:
          return state;
      }
  }



  function* handleWorker({ payload }) {
    yield put({type:actionTypes.reportTradeDetailLoad,payload:true})

    let config = {
      url: "select_request"
    };
  
    let data = {
      table: "imetrade",
      method_type: "report_trade_detail",
      from: payload?.from ? (payload.from * 10) :payload.from,
      size: payload?.size,
      data: payload?.data ? payload.data : {},
      sort_by: payload?.sort_by ? payload?.sort_by :{} ,
    };
  
    try {
      
      let res = yield AxiosCustom(config, data); 
    
      yield put({
        type: actionTypes.reportTradeDetail,
        payload: res.data.response.data
      });
      yield put({type:actionTypes.reportTradeDetailLoad,payload:false})
      
    } catch {
    //   handleNotificationAlertCatch();
    yield put({type:actionTypes.reportTradeDetailLoad,payload:false})
    }
  }
  
  export function* reportTradeDetailWorker() {
    yield takeLatest(actionTypes.reportTradeDetailAsync, handleWorker);
  }
  